import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appApenasAlfaNumerico]'
})
export class ApenasAlfaNumericoDirective {

  @Input() permitirEspaco: boolean = false; // Permitir espaços (opcional)
  @Input() permitirAcentos: boolean = false; // Permitir acentuação (opcional)
  @Input() apenasLetras: boolean = false; // Permitir apenas letras (opcional)


  constructor(private el: ElementRef) {}

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent): void {
    const inputChar = String.fromCharCode(event.keyCode || event.charCode);
    this.validate(event, inputChar);
  }

  @HostListener('paste', ['$event'])
  onPaste(event: Event) {
    const pastedText = (window as any).clipboardData && (window as any).clipboardData.getData('Text') // If IE, use window
      || event as ClipboardEvent && (event as ClipboardEvent).clipboardData.getData('text/plain'); // Non-IE browsers
    this.validate(event, pastedText);
  }

  validate(event: Event, text: string) {
    const regex = new RegExp(this.getRegexPattern());
    if (!regex.test(text)) {
      event.preventDefault();
    }
  }

  private getRegexPattern(): string {
    const ACCENTS = 'áàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ';
    const patternMap: Record<string, string> = {
      'letters-space-accents': `^[a-zA-Z\\s${ACCENTS}]*$`,
      'letters-space':         '^[a-zA-Z\\s]*$',
      'letters-accents':       `^[a-zA-Z${ACCENTS}]*$`,
      'letters':               '^[a-zA-Z]*$',
      'all-space-accents':     `^[a-zA-Z0-9\\s${ACCENTS}]*$`,
      'all-space':             '^[a-zA-Z0-9\\s]*$',
      'all-accents':           `^[a-zA-Z0-9${ACCENTS}]*$`,
      'all':                   '^[a-zA-Z0-9]*$',
    };
    const base    = this.apenasLetras   ? 'letters' : 'all';
    const space   = this.permitirEspaco ? '-space'   : '';
    const accents = this.permitirAcentos ? '-accents' : '';
    return patternMap[`${base}${space}${accents}`];
  }
}
